const SalesHomepageUrl = '/';

export default SalesHomepageUrl;
